
import { Button } from 'reactstrap'
import React, { useEffect, useRef } from 'react';


const CommonFileUpload = ({ selectedAttachFiles, setSelectedAttachFiles, attachFileNames, setAttachFileNames, type = 'txn', clearStatus, disable, clearAttachmentEdit }) => {

    const fileInputRef = useRef(null);
    const ApiURL = window.Links.ApiURL
    const authToken = localStorage.getItem("authToken")

    useEffect(() => {
        if (fileInputRef.current) {
            fileInputRef.current.value = null;
            setSelectedAttachFiles([]);
            setAttachFileNames([]);
        }
    }, [clearStatus]);

    useEffect(() => {
        if (fileInputRef.current) {
            fileInputRef.current.value = null;
            setSelectedAttachFiles([]);
        }
    }, [clearAttachmentEdit])

    const handleFileChange = (e) => {
        const files = Array.from(e.target.files);
        setSelectedAttachFiles(files);
    };

    const removeFile = (lineNo) => {

        setAttachFileNames((prevFiles) => {
            const updatedFiles = prevFiles.filter((file) => file.lineNo !== lineNo);

            // Reorganize lineNo values
            const reorganizedFiles = updatedFiles.map((file, index) => ({
                ...file,
                lineNo: index + 1,
            }));

            return reorganizedFiles;
        });
    };



    const handleUpload = async () => {
        try {

            if (selectedAttachFiles.length === 0) return

            const formData = new FormData();

            selectedAttachFiles.forEach((file, index) => {
                formData.append(`files[${index}]`, file);
            });

            formData.append('type', type);

            let requestOptions = {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${authToken}`
                },
                body: formData,
                redirect: 'follow'
            };

            const response = await fetch(`${ApiURL}txn/file`, requestOptions);
            const responseData = await response.json();

            // Find the highest fileId in the existing array


            let newFileNames = [...attachFileNames, ...responseData.data];

            // Add the fileId to the new files
            newFileNames = newFileNames.map((file, index) => {
                return { ...file, lineNo: index + 1 };
            });


            setAttachFileNames(newFileNames);

            // Clear the file input
            if (fileInputRef.current) {
                fileInputRef.current.value = null;
                setSelectedAttachFiles([]);
            }

        } catch (error) {
            console.error('Error uploading files:', error);
        }
    };

    const handleDownload = async (fileName) => {
        try {
            const response = await fetch(`${ApiURL}txn/file/${fileName}/${type}`, {
                headers: {
                    Authorization: `Bearer ${authToken}`,
                },
                method: 'GET',
            });

            if (response.ok) {
                const blob = await response.blob();
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', fileName);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            } else {
                console.error(`Error downloading file. Server returned status: ${response.status}`);
                // Handle other error scenarios if needed
            }
        } catch (error) {
            console.error('Error downloading file:', error.message);
            // Handle other error scenarios if needed
        }
    };

    const TableStyle = {
        container: {
            width: '100%',
            marginTop: '20px',
        },
        table: {
            width: '100%',
            borderCollapse: 'collapse',
            border: '1px solid #ddd', // Add border
        },
        th: {
            backgroundColor: '#f2f2f2',
            padding: '8px',
            textAlign: 'left',
        },
        thBtn: {
            backgroundColor: '#f2f2f2',
            padding: '8px',
            textAlign: 'center',
        },
        td: {
            border: '1px solid #ddd',
            padding: '8px',
            textAlign: 'left',
            verticalAlign: 'top',
        },
        tdBtn: {
            border: '1px solid #ddd',
            padding: '8px',
            textAlign: 'center',
            verticalAlign: 'top',
        },
        button: {
            margin: '0',
        },
    };

    return (
        <div>
            <label htmlFor="fileInput">Select file to upload:</label>
            <div className="file-upload-section">
                <input id="fileInput" type="file" multiple onChange={handleFileChange} ref={fileInputRef} disabled={disable} />
                <Button size='sm' color='primary' onClick={handleUpload} disabled={disable ? true : selectedAttachFiles.length == 0 ? true : false}>Upload</Button>
                <Button size='sm' color='danger' className='mx-1' disabled={disable} onClick={() => {
                    if (fileInputRef.current) {
                        fileInputRef.current.value = null;
                        setSelectedAttachFiles([]);
                    }
                }}>Clear</Button>
            </div>

            <div style={TableStyle.container}>
                <table style={TableStyle.table} className="file-table">
                    <thead>
                        <tr>
                            <th style={TableStyle.th}>Line No</th>
                            <th style={TableStyle.th}>File Name</th>
                            <th style={TableStyle.thBtn}>Action</th>
                            <th style={TableStyle.th}></th>
                        </tr>
                    </thead>
                    <tbody>
                        {attachFileNames.map((files) => (
                            <tr key={files.lineNo} className="file-entry">
                                <td style={TableStyle.td}>{files.lineNo}</td>
                                <td style={TableStyle.td}>{files.fileName}</td>
                                <td style={TableStyle.tdBtn}>
                                    <Button size='sm' color='primary' style={TableStyle.button} onClick={() => handleDownload(files.fileName)}>
                                        Download
                                        <i className="mdi mdi-download" style={{ fontSize: '12px', marginRight: '5px' }}></i>
                                    </Button>
                                </td>
                                <td style={TableStyle.tdBtn}>
                                    <Button size='sm' color='danger' disabled={disable} onClick={() => removeFile(files.lineNo)} style={TableStyle.button}>Delete</Button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default CommonFileUpload;



